<template>
  <div class="home-view">
    <Navbar />
    <ReturnSolicitation v-if="selectedTab == 'return-request'" />
    <ReturnTracking v-if="selectedTab == 'return-tracking'" />
    <ScheduleCollection v-if="selectedTab == 'schedule-collection'" />
    <ReturnPolicy v-if="selectedTab == 'return-policy'" />
    <HomeFooter />
    <NotificationClient />
  </div>
</template>

<script>
import Navbar from "@/components/home/Navbar.vue";
import HomeFooter from "@/components/home/HomeFooter.vue";
import ReturnSolicitation from "@/components/home/return-solicitation/ReturnSolicitation.vue";
import ReturnTracking from "@/components/home/return-tracking/ReturnTracking.vue";
import ScheduleCollection from "@/components/home/schedule-collection/ScheduleCollection.vue";
import ReturnPolicy from "@/components/home/return-policy/ReturnPolicy.vue";
import NotificationClient from "@/components/notificationClient/NotificationClient";
import { EventBus } from "@/eventHub";

export default {
  name: "home",
  components: {
    Navbar,
    HomeFooter,
    ReturnSolicitation,
    ReturnTracking,
    ScheduleCollection,
    ReturnPolicy,
    NotificationClient
  },
  data() {
    return {
      selectedTab: "return-request"
    };
  },
  created() {
    EventBus.$on("tabChanged", tab => {
      this.selectedTab = tab;
    });
  }
};
</script>
<style lang="scss" scoped>
.home-view {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 100%;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0%);
  font-family: Centuma;
}
</style>
